var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointingArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9988 0.00038329L0.998817 0.000381716C0.816575 0.000952951 0.637941 0.0512163 0.482141 0.14576C0.326341 0.240303 0.199275 0.375547 0.114621 0.536934C0.0299676 0.698322 -0.00906821 0.879742 0.00171402 1.06166C0.0124962 1.24359 0.0726902 1.41912 0.175817 1.56938L9.17582 14.5694C9.54882 15.1084 10.4468 15.1084 10.8208 14.5694L19.8208 1.56938C19.925 1.41944 19.9861 1.24381 19.9975 1.06159C20.0088 0.879362 19.97 0.697505 19.8853 0.535776C19.8006 0.374047 19.6731 0.238629 19.5169 0.144239C19.3606 0.0498495 19.1814 9.52959e-05 18.9988 0.00038329Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointingArrow);
export default __webpack_public_path__ + "static/media/pointingArrow.9bc617f25e5eb68787d660739672c6c4.svg";
export { ForwardRef as ReactComponent };